import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { merge, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
  selector: 'app-type-ahead',
  templateUrl: './type-ahead.component.html',
  styleUrls: ['./type-ahead.component.scss']
})
export class TypeAheadComponent implements OnInit, OnChanges {
  @Input() labelForSearchType: {isLabelRequired: boolean, labelValue: string};
  @Input() listOfSearchItems: {name: string, optionsDisplayname: string, value: any, label: string}[];
  @Input() defaultItem: {name: string, optionsDisplayname: string, value: any, label: string};
  @Input() maxOptionsCount: number;
  @Output() selectedItem: EventEmitter<{name: string, optionsDisplayname: string, value: any}> = new EventEmitter<{name: string, optionsDisplayname: string, value: any}>();
  @ViewChild('instance') instance: NgbTypeahead;

  focus$: Subject<string> = new Subject<string>();
  click$: Subject<string> = new Subject<string>();

  typeaheadModel: {name: string, optionsDisplayname: string, value: any};

  formatter = (result: {name: string, optionsDisplayname: string, value: any}) => result.name;
  index :number = 0;

  constructor() { }

  ngOnInit() {}
  

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.defaultItem && changes.defaultItem.currentValue !== changes.defaultItem.previousValue) {
      this.typeaheadModel = _.cloneDeep(this.listOfSearchItems[this.index]);
    }
  }

  search = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(500), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => term === '' ? this.listOfSearchItems
        : this.listOfSearchItems.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, this.maxOptionsCount))
    );
  }

  getSelectedItesmByterritoryId(tId) {
    let result: any;
    if (this.listOfSearchItems) {
       this.index = this.listOfSearchItems.map(i => i.value.territoryId).indexOf(tId);
      if (this.index !== -1) {
        result = this.listOfSearchItems[this.index];
      }
    }
    return result;
  }

  onSelectionChange() {
    let item = this.getSelectedItesmByterritoryId(this.typeaheadModel.value.territoryId);
    this.typeaheadModel = _.cloneDeep(this.listOfSearchItems[this.index]);
    this.selectedItem.emit(this.typeaheadModel);
  }
}